// eslint-disable-next-line import/prefer-default-export
export const APP_BASENAME = '/apps/client';
